/* eslint-disable max-len */
import axios from 'axios';

const API_URL = 'https://zb-backend-v2-test.herokuapp.com/';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default api;
